import React from 'react';
import { Skeleton } from 'antd';
import { useGetTripTasks } from 'api/trip-task/use-get-trip-tasks';
import { useGetArrivalInformation } from 'api/trips/use-get-arrival-information';
import { useGetCargoTrips } from 'api/trips/use-get-cargo-trips';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { TripMapContainer } from 'components/map/map-container';
import { TripArrivalInformation } from 'components/map/map-container/components/trip-arrival-information';
import type { IPreviewModalContentProps } from './types';

export const PreviewModalContent: React.FC<IPreviewModalContentProps> = (props) => {
  const { selectedTrip, clientOrderNumber } = props;
  const { data: cargoTrips, isLoading: isCargoTripsLoading } = useGetCargoTrips(selectedTrip?.id);
  const { data: warehouses, isLoading: isWarehousesLoading } = useGetManyWarehouses();
  const { data: tripTasks, isLoading: isTripTasksLoading } = useGetTripTasks({ tripId: selectedTrip.id });

  const { data: arrivalInformation } = useGetArrivalInformation(selectedTrip.id, {
    enabled: true,
  });

  const isLoading = isCargoTripsLoading || isWarehousesLoading || isTripTasksLoading;

  if (isLoading) return <Skeleton loading={isLoading} />;

  const trailerPlateNumber = selectedTrip.trailer?.plateNumber ?? selectedTrip.trailerPlate;

  return (
    <>
      <TripMapContainer
        tripTasks={tripTasks}
        cargoTrips={cargoTrips}
        transports={[selectedTrip.truck]}
        warehouses={warehouses}
      />
      <TripArrivalInformation arrivalInformation={arrivalInformation} />
      {clientOrderNumber ? <strong>{clientOrderNumber}</strong> : null}
      {selectedTrip.truck ? (
        <>
          <div>
            Truck: {selectedTrip.truck?.plateNumber}
            {trailerPlateNumber ? ` / ${trailerPlateNumber}` : null}
          </div>
          <div>Driver: {selectedTrip.truck?.driverFullName}</div>
        </>
      ) : null}
    </>
  );
};
